var _defs, _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarningBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    width: 70,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-success-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 48,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAwCAMAAAAfDRtEAAAAAXNSR0IB2cksfwAAAK5QTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXshTpQAAADp0Uk5TABg0NRkf1PTVIbv/vhsgLDArE/v8F6erFLr5+hUBBzxeae1sBYuP6+wtSf5MKOjpKmRnXeH3Xzc4ImxoSUYAAACSSURBVHic7dDHEoJAEATQNiKsiophDQuImAAzGP7/x9ydsYqb/oB9ejWXnmoAqFRrdVAaTctq2URH6LSNOoLS1XSZvT9/sF9y4BkNR2bKseGE9pXT2dxZ8OxKSoUv8YMwDHziMhIiWmnEa67YxHC3zN0eScpMMyTikwyHI+t0hrrQO97VFN7yosjv/IL9eL707Q0TdRXeWb0sKQAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { display: none;fill: #00d0a6 } \n\t\t.s2 { fill: #000000;stroke: #000000;stroke-linecap: round;stroke-width: 4.8 } \n\t\t.s3 { fill: #000000;stroke: #000000;stroke-linecap: round;stroke-width: 7.1 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m35 69.2c-6.8 0-13.4-2-19-5.8-5.6-3.7-10-9.1-12.6-15.3-2.6-6.3-3.3-13.1-1.9-19.8 1.3-6.6 4.5-12.7 9.3-17.5 4.8-4.8 10.9-8 17.5-9.3 6.7-1.4 13.5-0.7 19.8 1.9 6.2 2.6 11.6 7 15.3 12.6 3.8 5.6 5.8 12.2 5.8 19 0 0.5-0.2 0.9-0.5 1.3-0.3 0.3-0.8 0.5-1.3 0.5-0.4 0-0.9-0.2-1.2-0.5-0.3-0.4-0.5-0.8-0.5-1.3 0-7.5-2.8-14.8-7.9-20.4-5-5.6-11.9-9.2-19.4-10-7.5-0.8-15 1.2-21.2 5.6-6.1 4.4-10.4 10.9-12 18.2-1.6 7.4-0.5 15.1 3.2 21.7 3.7 6.5 9.7 11.5 16.8 13.9 7.2 2.4 14.9 2.2 21.9-0.8 6.9-3 12.5-8.4 15.7-15.2 0.2-0.4 0.6-0.7 1-0.9 0.4-0.1 0.9-0.1 1.3 0.1 0.4 0.2 0.8 0.5 0.9 1 0.2 0.4 0.2 0.9 0 1.3-2.8 5.9-7.2 10.9-12.7 14.3-5.4 3.5-11.8 5.4-18.3 5.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m29.6 48.3c-0.5 0-0.9-0.2-1.3-0.5l-8.8-8.6q-0.3-0.2-0.5-0.6-0.1-0.3-0.1-0.6-0.1-0.4 0.1-0.7 0.1-0.4 0.4-0.6 0.2-0.3 0.5-0.4 0.4-0.2 0.7-0.2 0.4 0 0.7 0.2 0.4 0.1 0.6 0.4l7.5 7.3 17.7-21.7c0.3-0.3 0.7-0.5 1.2-0.6 0.4 0 0.9 0.1 1.2 0.4 0.4 0.3 0.6 0.7 0.7 1.2 0 0.4-0.1 0.9-0.4 1.2l-18.9 23.2q-0.2 0.2-0.6 0.4-0.3 0.2-0.7 0.2z"
  })), /*#__PURE__*/React.createElement("use", {
    id: "c9ec357354314ccaf618d173bb05bdc6",
    style: {
      display: "none"
    },
    href: "#img1",
    x: 30,
    y: 11
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Forma 1",
    className: "s2",
    d: "m35 15v28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Forma 2",
    className: "s3",
    d: "m35 54zm0 0zm0 0v0.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m66.3 43.5q-0.1 0.1-0.3 0-0.2 0-0.4-0.1-0.2-0.1-0.3-0.2-0.3-0.2-0.5-0.5-0.1-0.1-0.2-0.3-0.1-0.2-0.1-0.4-0.1-0.3 0-0.7 0-0.2 0.1-0.4 0.1-0.1 0.2-0.3 0.1-0.2 0.2-0.3 0.1-0.1 0.3-0.2 0.1-0.1 0.3-0.2 0.2-0.1 0.4-0.1 0.3-0.1 0.7 0 0.2 0 0.4 0.1 0.1 0.1 0.3 0.2 0.3 0.2 0.5 0.5 0.1 0.2 0.2 0.3 0.1 0.2 0.1 0.4 0.1 0.4 0 0.7 0 0.2-0.1 0.4-0.1 0.2-0.2 0.3-0.1 0.2-0.2 0.3-0.1 0.1-0.3 0.2-0.2 0.1-0.3 0.2-0.2 0.1-0.4 0.1-0.2 0-0.4 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningBlack);
export default __webpack_public_path__ + "static/media/icon-warning-black.3f22ddded5f7160787cf887aaf6399df.svg";
export { ForwardRef as ReactComponent };